const container = document.querySelector('.header');
const menuItems = document.querySelectorAll('.mega-menu');

function updateHeaderState() {
  const isAnyOpen = Array.from(menuItems).some(item => item.hasAttribute('open'));
  container.classList.toggle('active', isAnyOpen);
}

// Set up observer
const observer = new MutationObserver(updateHeaderState);

// Observe each .mega-menu for attribute changes
menuItems.forEach(item => {
  observer.observe(item, { attributes: true, attributeFilter: ['open'] });
});

// Initial check
updateHeaderState();

// Mobile menu toggle

// document.querySelector('.close-btn-mobile-menu').addEventListener('click', function () {
//   const menuDrawer = document.querySelector('.menu-drawer-container');
  
//   if (menuDrawer) {
//     menuDrawer.classList.remove('open', 'menu-opening');
//     menuDrawer.removeAttribute('open');
//   }
// });

 document.addEventListener("DOMContentLoaded", function () {
    const progressBar = document.querySelector(".progress-bar");
    const current = parseFloat(progressBar.getAttribute("data-count")) || 0;
    const max = 60;
    const percentage = Math.min((current / max) * 100, 100);
    progressBar.style.width = percentage + "%";
  });


document.addEventListener("DOMContentLoaded", function () {
  document.body.classList.remove("preload");
});


// illustration animation

document.addEventListener("DOMContentLoaded", function () {
  const imageContainers = document.querySelectorAll(".multiple-img-banner-section");

  const observer = new IntersectionObserver(
    (entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("active");
          observer.unobserve(entry.target); // Stop observing after activating
        }
      });
    },
    {
      threshold: 0.1 // Adjust as needed
    }
  );

  imageContainers.forEach((container) => {
    observer.observe(container);
  });
});

document.addEventListener("DOMContentLoaded", function () {
  const imageContainers = document.querySelectorAll(".text-with-multiple-image-section");

  const observer = new IntersectionObserver(
    (entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("active");
          observer.unobserve(entry.target); // Stop observing after activating
        }
      });
    },
    {
      threshold: 0.1 // Adjust as needed
    }
  );

  imageContainers.forEach((container) => {
    observer.observe(container);
  });
});


document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll('.menu-drawer-item-title-wrapper').forEach(wrapper => {
    wrapper.addEventListener('click', function () {
      const parent = wrapper.closest('.menu-drawer-item');
      const content = parent.querySelector('.menu-drawer--submenu');
      const isActive = parent.classList.contains('active');

      document.querySelectorAll('.menu-drawer-item').forEach(item => {
        item.classList.remove('active');
        item.querySelector('.menu-drawer--submenu').style.maxHeight = null;
      });

      if (!isActive) {
        parent.classList.add('active');
        content.style.maxHeight = content.scrollHeight + "px";
      }
    });
  });

  document.querySelectorAll('.nested-accordion-title').forEach(title => {
    title.addEventListener('click', function () {
      const item = title.closest('.nested-accordion-item');
      const content = item.querySelector('.nested-accordion-content');
      const parentSubmenu = item.closest('.menu-drawer--submenu');
      const isActive = item.classList.contains('active');

      item.parentElement.querySelectorAll('.nested-accordion-item').forEach(sib => {
        sib.classList.remove('active');
        sib.querySelector('.nested-accordion-content').style.maxHeight = null;
      });

      if (!isActive) {
        item.classList.add('active');
        content.style.maxHeight = content.scrollHeight + "px";

        setTimeout(() => {
          parentSubmenu.style.maxHeight = parentSubmenu.scrollHeight + "px";
        }, 300); // Match transition duration
      }
    });
  });
});

// Header scrolled JS

(function () {
  const headerGroup = document.querySelector('.shopify-section-group-header-group');
  if (!headerGroup) return;

  let ticking = false;
  let lastScrollY = window.scrollY;

  function updateHeaderClasses() {
    const scrollY = window.scrollY;
    const viewportHeight = window.innerHeight;

    // At the very top of the page
    headerGroup.classList.toggle('is-at-top', scrollY <= 0);

    // Scrolled down at all (not at top)
    headerGroup.classList.toggle('is-scrolled', scrollY > 0);

    // Scrolled past one full viewport height
    headerGroup.classList.toggle('is-scrolled-100vh', scrollY >= viewportHeight);

    // Scroll direction
    if (scrollY > lastScrollY && scrollY > 0) {
      headerGroup.classList.add('is-scrolling-down');
      headerGroup.classList.remove('is-scrolling-up');
    } else if (scrollY < lastScrollY) {
      headerGroup.classList.add('is-scrolling-up');
      headerGroup.classList.remove('is-scrolling-down');
    }

    lastScrollY = scrollY;
    ticking = false;
  }

  function onScroll() {
    if (!ticking) {
      requestAnimationFrame(updateHeaderClasses);
      ticking = true;
    }
  }

  window.addEventListener('scroll', onScroll, { passive: true });

  // Set initial state on load
  updateHeaderClasses();
})();

// Announcement bar transition
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.announcement-bar-rotator[data-autoplay="true"]').forEach(function (rotator) {
    const slides = Array.from(rotator.querySelectorAll('.announcement-bar__text'));
    if (slides.length <= 1) return;

    let activeIndex = 0;
    const intervalMs = 3000;

    setInterval(function () {
      slides[activeIndex].classList.remove('is-active');
      activeIndex = (activeIndex + 1) % slides.length;
      slides[activeIndex].classList.add('is-active');
    }, intervalMs);
  });
});

// Mega menu

document.addEventListener('DOMContentLoaded', function () {
  const summaries = document.querySelectorAll('.mega-menu summary');
  const header = document.querySelector('.header');

  if (!header) return; // bail early if header isn't found

  function updateHeaderActiveClass() {
    const hasActiveMenu = document.querySelector('.mega-menu__content.active');
    header.classList.toggle('active', !!hasActiveMenu);
  }

  summaries.forEach(function (summary) {
    summary.addEventListener('click', function (event) {
      event.stopPropagation();

      const content = summary.closest('.mega-menu')?.querySelector('.mega-menu__content');
      if (!content) return;

      const isActive = content.classList.contains('active');
      const menuHandle = content.dataset.menuHandle;

      document.querySelectorAll('.mega-menu__content.active').forEach(function (el) {
        el.classList.remove('active');
        if (el.dataset.menuHandle) {
          el.classList.remove(el.dataset.menuHandle + '-active');
        }
      });
      document.querySelectorAll('.header__menu-item.active').forEach(function (el) {
        el.classList.remove('active');
      });

      if (!isActive) {
        content.classList.toggle('active');
        if (menuHandle) {
          content.classList.toggle(menuHandle + '-active');
        }
        summary.classList.toggle('active');
      }

      updateHeaderActiveClass();
    });
  });

  header.addEventListener('click', function (e) {
    if (!e.target.closest('summary')) {
      document.querySelectorAll('.mega-menu__content.active').forEach(function (el) {
        el.classList.remove('active');
        if (el.dataset.menuHandle) {
          el.classList.remove(el.dataset.menuHandle + '-active');
        }
      });
      document.querySelectorAll('.header__menu-item.active').forEach(function (el) {
        el.classList.remove('active');
      });
      updateHeaderActiveClass();
    }
  });

  document.querySelectorAll('.mega-menu__content').forEach(function (menu) {
    const featuredImage = menu.querySelector('.megamenu-featured-content .img-wrapper img');
    const featuredWrapper = menu.querySelector('.featured-content-wrapper');
    const featuredHeading = featuredWrapper?.querySelector('.featured-content-wrapper__footer h3');
    const menuLinks = menu.querySelectorAll('.mega-menu__list .mega-menu__link');

    if (!featuredImage || !featuredWrapper || !menuLinks.length) return;

    const defaultImage = featuredWrapper.dataset.defaultImage || featuredImage.src;
    const defaultHeading = featuredWrapper.dataset.defaultHeading || featuredHeading?.textContent;
    const defaultLink = featuredWrapper.getAttribute('href');
    const defaultAriaLabel = featuredWrapper.getAttribute('aria-label');

    const imageUrls = new Set(
      Array.from(menuLinks)
        .map(function (menuLink) {
          return menuLink.dataset.menuImage;
        })
        .filter(Boolean)
    );

    imageUrls.forEach(function (imageUrl) {
      const preloadImage = new Image();
      preloadImage.src = imageUrl;
    });

    menuLinks.forEach(function (menuLink) {
      function showMenuImage() {
        const menuLinkText = menuLink.textContent.trim();

        featuredImage.src = menuLink.dataset.menuImage || defaultImage;
        featuredWrapper.setAttribute('href', menuLink.getAttribute('href'));
        featuredWrapper.setAttribute('aria-label', `View all in ${menuLinkText}`);
        if (featuredHeading) featuredHeading.textContent = menuLinkText;
      }

      menuLink.addEventListener('mouseenter', showMenuImage);
      menuLink.addEventListener('focus', showMenuImage);
    });

    menu.addEventListener('mouseleave', function () {
      featuredImage.src = defaultImage;
      featuredWrapper.setAttribute('href', defaultLink);
      featuredWrapper.setAttribute('aria-label', defaultAriaLabel);
      if (featuredHeading && defaultHeading) featuredHeading.textContent = defaultHeading;
    });
  });
});

// Predictive search

document.addEventListener('DOMContentLoaded', () => {
  const allDetails = document.querySelectorAll('.header__search details');

  if (!allDetails.length) return;

  allDetails.forEach((details) => {
    details.addEventListener('toggle', () => {
      const isAnyOpen = Array.from(allDetails).some((d) => d.open);
      document.body.classList.toggle('search-is-open', isAnyOpen);
    });
  });
});


// scroll section

// document.addEventListener('DOMContentLoaded', () => {
//   const sections = Array.from(
//     document.querySelectorAll('.shopify-section')
//   );

//   let wrapper = null;

//   sections.forEach((section) => {
//     const isScrollSection =
//       section.classList.contains('section-scroll-banner');

//     if (isScrollSection) {
//       if (!wrapper) {
//         wrapper = document.createElement('div');
//         wrapper.className = 'section-scroll-wrapper';

//         section.before(wrapper);
//       }

//       wrapper.appendChild(section);
//     } else {
//       wrapper = null;
//     }
//   });
// });

document.addEventListener('DOMContentLoaded', () => {
  const sections = document.querySelectorAll('.section-scroll-banner');

  sections.forEach((section) => {
    const media = section.querySelector('.history-journey__media');

    if (!media) return;

    /* Create wrapper for each sticky section */
    const wrapper = document.createElement('div');
    wrapper.className = 'section-scroll-item';

    section.parentNode.insertBefore(wrapper, section);
    wrapper.appendChild(section);

    const updateHeight = () => {
      const mediaScrollDistance =
        media.scrollHeight - media.clientHeight;

      /*
       * Wrapper must be tall enough for:
       * 1. one viewport containing the sticky section
       * 2. the amount required to scroll through media content
       */
      wrapper.style.height = `${
        section.offsetHeight + mediaScrollDistance
      }px`;
    };

    const updateScroll = () => {
      const rect = wrapper.getBoundingClientRect();

      /*
       * How far we've travelled through this wrapper.
       */
      const scrollProgress = Math.max(0, -rect.top + 109);

      const maxScroll =
        media.scrollHeight - media.clientHeight;

      media.scrollTop = Math.min(
        Math.max(scrollProgress, 0),
        maxScroll
      );
    };

    updateHeight();
    updateScroll();

    window.addEventListener('scroll', updateScroll, {
      passive: true
    });

    window.addEventListener('resize', () => {
      updateHeight();
      updateScroll();
    });
  });
});
